import { FC, ReactNode, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ClientInfoStep from "./steps/ClientInfoStep";
import { useSelector } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import { message } from "antd";
import ClientOTPStep from "./steps/ClientOTPStep";
import { clientAuthReSendOtp } from "../../../../network/clientSide";
import { useIntl } from "react-intl";

interface ClientRegisterProps {}

const ClientRegister: FC<ClientRegisterProps> = ({}) => {
  const intl = useIntl();
  const { phoneNumber, phoneCountryCode } = useSelector(
    (state: {
      cart: {
        client: { phoneNumber: string | null; phoneCountryCode: string | null };
      };
    }) => state.cart.client
  );
  const [stepIndex, setStepIndex] = useState(0);
  // const [searchParams, setSearchParams] = useSearchParams();
  // const [stepIndex, setStepIndex] = useState(
  //   searchParams.get("step") &&
  //     Number(searchParams.get("step")) >= 0 &&
  //     Number(searchParams.get("step")) <= 2
  //     ? Number(searchParams.get("step"))
  //     : 0
  // );
  const reSendOtpMutate = useMutation(clientAuthReSendOtp);

  // useEffect(() => {
  //   setStepIndex(
  //     searchParams.get("step") &&
  //       Number(searchParams.get("step")) >= 0 &&
  //       Number(searchParams.get("step")) <= 3
  //       ? Number(searchParams.get("step"))
  //       : 0
  //   );
  // }, [searchParams]);

  const nextStep = () => {
    if (stepIndex < steps.length - 1) {
      // searchParams.set("step", `${stepIndex + 1}`);
      // setSearchParams(searchParams);
      setStepIndex((prev) => prev + 1);
    }
    return false;
  };
  const prevStep = () => {
    if (stepIndex > 0) {
      // searchParams.set("step", `${stepIndex - 1}`);
      // setSearchParams(searchParams);
      setStepIndex((prev) => prev - 1);
    }
    return false;
  };
  const reSendOtp = async () => {
    if (!phoneNumber) return;
    reSendOtpMutate.mutate(
      {
        phone: phoneNumber,
        phone_country_code: phoneCountryCode,
      },
      {
        onSuccess: (res: any) => {
          if (res?.code !== "ERR_BAD_REQUEST") {
            message.success(intl.formatMessage({ id: "OTPSENT" }));
          } else {
            message.error(
              res?.response?.data?.message ||
                intl.formatMessage({ id: "tryAgain" })
            );
          }
        },
        onError: () => {
          message.error(intl.formatMessage({ id: "tryAgain" }));
        },
      }
    );
  };
  const steps: ReactNode[] = [
    <ClientInfoStep nextStep={nextStep} />,

    phoneNumber && phoneCountryCode && (
      <ClientOTPStep
        reSendOtp={reSendOtp}
        phone={phoneNumber}
        countryCode={phoneCountryCode}
        config={{
          header: true,
          stepBack: -3,
        }}
      />
    ),
  ];
  return (
    <div className="shadow p-6 space-y-4 rounded-lg ">
      <div className="space-y-4">
        <h4 className="text-color-primary text-xl ">
          {intl.formatMessage({ id: "joinLookfindr" })}
        </h4>
        <p className="text-color-sec-title">
          {intl.formatMessage({ id: "completeToJoin" })}
        </p>
      </div>
      <div>{steps[stepIndex]}</div>
    </div>
  );
};

export default ClientRegister;
